import React, { HTMLProps } from 'react';
import CloseButton from '@/components/UI/Buttons/CloseButton';
import classNames from 'classnames';

interface ModalLayoutProps extends HTMLProps<HTMLDivElement> {
  close?: () => void;
}

export const ModalLayout = ({ children, close, ...props }: ModalLayoutProps) => (
  <div
    {...props}
    className={classNames(
      'relative max-w-full w-full overflow-y-auto rounded-xl bg-white text-left md:max-w-xl',
      props.className,
    )}
  >
    {close && (
      <div className="w-full flex justify-start pt-4 pr-4">
        <CloseButton dataCy="close-modal" onClick={() => close()} />
      </div>
    )}
    <div className="p-4 md:p-8 flex justify-center">{children}</div>
  </div>
);
